import React from 'react';
import Title from "../../../components/Title";
import {Button} from "../../../components/Button";
import moment from "moment";
import connect from "react-redux/es/connect/connect";
import {config} from "../../../../config";
import {bindActionCreators} from "redux";
import {fetchCurrentUser, updateCurrentUser} from "../../../../creators/currentUser";
import Icon from "../../../components/Icon";
import {PageLoader} from "../../../components/Loader";
import {
    DateInputFieldBirthday,
    SelectField,
    TextAreaField
} from "../../../components/FormField";
import Helmet from "react-helmet";

class ProfilSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleAvatarUp: false,
            toggleCoverUp: false,
            gender: 0,
            description: "",
            informations: [],
            //newsletter : false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCurrentUser = this.handleCurrentUser.bind(this);
        this.handleProfileInformations = this.handleProfileInformations.bind(this);
        this.handleProfileBirthday = this.handleProfileBirthday.bind(this);
        this.handleGender = this.handleGender.bind(this);
    }

    componentDidMount(oldProps) {
        this.props.fetchCurrentUser();
        const newProps = this.props;
        if ((oldProps && oldProps.currentUserInitialized !== newProps.currentUserInitialized) || newProps.currentUserInitialized === true) {
            let profile = newProps.currentUser.profile;
            //let setting = newProps.currentUser.setting;
            this.setState({
                gender: profile.gender,
                description: profile.description,
                informations: profile.informations || [],
                //newsletter : setting.newsletter
            });
        }
    }

    handleCurrentUser(name, value) {
        this.setState({[name]: value})
    }
// 0=>NC, 1=>Homme, 2=>Femme, 3=>Couple, 4=>Couple lesbien, 5=>Couple gay, 6=>Travesti -  ex lookFor
    handleGender(value) {
        value = parseInt(value);
        let informations = this.state.informations.slice(0, 1);
        if (value === 3 || value === 4) {
            informations[0].sex = 0;
            informations.push({
                sex: 1,
                orientation: 0,
                birthday: ""
            })
        }
        if (value === 4) {
            informations[0].sex = 1;
        } else if (value === 5) {
            informations[0].sex = 0;
            informations.push({
                sex: 0,
                orientation: 0,
                birthday: ""
            })
        }
        this.setState({gender: value, informations})
    }

    handleProfileInformations(id, name, value) {
        let informations = this.state.informations;
        let informationIndex = informations.findIndex(item => item._id === id);
        informations[informationIndex][name] = parseInt(value);
        this.setState({informations});
    }

    handleProfileBirthday(id, value) {
        let informations = this.state.informations;
        let informationIndex = informations.findIndex(item => item._id === id);
        informations[informationIndex].birthday = value;
        this.setState({informations});
    }


    handleSubmit(event) {
        event.preventDefault();
        //event.stopPropagation();

        let currentUser = {
            profile: {
                gender: this.state.gender,
                description: this.state.description,
                informations: this.state.informations
            },
            /*setting : {
                newsletter : this.state.newsletter
            }*/
        };
        if (!this.props.currentUserLoading) {
            this.props.updateCurrentUser(currentUser);
        }
    }


    render() {

        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <div className="settings-wrapper">
                <Helmet>
                    <title>{config.preTitle}Paramètre de profil{config.postTitle}</title>
                </Helmet>
                <div className="block">
                    <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Mon profil</Title>
                    <form className="content" onSubmit={(e) => this.handleSubmit(e)}>
                        <label className="label-title" htmlFor="gender">Sexe</label>
                        <SelectField required={true} id="gender" value={this.state.gender || "0"} disabled name="gender"
                                     onChange={(event) => this.handleGender(event.target.value)}>
                            {config.genderList.map((name, index) => {
                                if (index > 0) {
                                    return <option value={index} key={index}>{name}</option>;
                                } else return null;
                            })}
                        </SelectField>
                        <span className="edit-span mb-16">Contacter l'équipe Voissa pour changer le genre de votre profil.</span>

                        <label htmlFor="description" className="label-title">A propos de moi</label>
                        <TextAreaField id="description" value={this.state.description}
                                       onChange={(event) => this.handleCurrentUser("description", event.target.value)}/>



                        <div className={"flex-table mt-16"}>
                            <div className={"row flex-1"}>
                                {this.state.informations.map((information, index) => (
                                    <div key={index} className={`column flex-table-column`}>
                                        {this.state.informations.length === 2 && (
                                            <div className="flex-table-content">
                                                <div
                                                    className={`flex-table-head-title ${information.sex === 0 ? 'him' : information.sex === 1 ? 'her' : ''}`}>
                                                    <Icon type={config.genderClass[information.sex]}/>
                                                    {information.sex === 0 ? (
                                                        "Lui"
                                                    ) : information.sex === 1 && (
                                                        "Elle"
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                        <div className="flex-table-content">
                                            <div className={"flex-table-label"}>Anniversaire</div>
                                            <DateInputFieldBirthday
                                                value={information.birthday || moment().subtract(18, 'years').toDate()}
                                                format={"DD/MM/YYYY"}
                                                nameOfValueToUpdate={information._id}
                                                convertToFormat={"YYYY-MM-DD"}
                                                maxDate={moment().subtract(18, 'years').toDate()}
                                                minDate={moment().subtract(150, 'years').toDate()}
                                                handleValue={this.handleProfileBirthday}/>
                                            <span
                                                className="edit-span">La saisie de votre anniversaire est facultative</span>
                                        </div>
                                        <div className="flex-table-content">
                                            <div className={"flex-table-label"}>Orientation</div>
                                            <SelectField value={information.orientation}
                                                         onChange={(event) => this.handleProfileInformations(information._id, "orientation", event.target.value)}>
                                                {config.orientation.map((name, orientationIndex) => (
                                                    <option value={orientationIndex}
                                                            key={orientationIndex}>{name}</option>
                                                ))}
                                            </SelectField>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*<CheckboxInputField checked={this.state.newsletter}
                                                onChange={() => this.setState({newsletter : !this.state.newsletter})}
                                                htmlFor="newsletter"
                                                id="newsletter"
                                                className={"my-8"}
                                                label={"Recevoir la newsletter hebdomadaire"}/>*/}
                        </div>
                        <div className="settings-btn-group">
                            <Button size={"medium"}
                                    btnType={"submit"}
                                    loading={this.props.currentUserSubmitting}
                                    btnStyle={"primary-reverse"}
                                    content={"Enregistrer"}/>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserSubmitting: state.currentUser.submitting,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfilSettings);